export const PLUS = ({ color, ...props }: React.ComponentPropsWithRef<'svg'>) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 0L12 24' stroke='#FCFBF9' strokeWidth='3' strokeLinejoin='round' />
    <path d='M24 12L0 12' stroke='#FCFBF9' strokeWidth='3' strokeLinejoin='round' />
  </svg>
);
